import { render, staticRenderFns } from "./personnelData.vue?vue&type=template&id=5ca3bf83&scoped=true"
import script from "./personnelData.vue?vue&type=script&lang=js"
export * from "./personnelData.vue?vue&type=script&lang=js"
import style0 from "./personnelData.vue?vue&type=style&index=0&id=5ca3bf83&prod&scoped=true&lang=scss"
import style1 from "./personnelData.vue?vue&type=style&index=1&id=5ca3bf83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3bf83",
  null
  
)

export default component.exports